<template>
  <div>
    <section class="repricing-page" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">
            <div class="header--reservation-detail">
              <div class="header--reservation-box">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-35 pz">
                    <li class="breadcrumb-item">
                      <router-link
                        :to="
                          $route.path.includes('tenant')
                            ? `/job/tenant/${$route.params.id}`
                            : `/reservation/inquiry/${$route.params.id}`
                        "
                      >
                        {{
                          $route.path.includes("tenant")
                            ? "Tenant Job Detail"
                            : "Reservation Summary"
                        }}
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Repricing
                    </li>
                  </ol>
                </nav>
                <h4>Booking Details</h4>
                <div class="table-legend">
                  <ul>
                    <li v-if="isAirportTransfer">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-else><i class="ic-time"></i>Hourly Booking</li>
                  </ul>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Payment Status</div>
                <div class="label-title">
                  <span
                    v-if="reservation.paymentStatus === 'Complete'"
                    class="--green35"
                    >Completed</span
                  >
                  <span v-else class="sts-danger">{{
                    humanize(reservation.paymentStatus)
                  }}</span>
                </div>
              </div>
              <div
                class="label-group"
                v-if="reservation.paymentMethodDescription"
              >
                <div class="label">Payment Method</div>
                <div class="label-title">
                  <span>{{ reservation.paymentMethodDescription }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Code</div>
                <div class="label-title">
                  <span>{{ reservation.code }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Date</div>
                <div class="label-title">
                  <span>{{ reservation.reservationDate.stringFullDate }} </span>
                </div>
              </div>
            </div>
          </div>

          <div class="service-type-wrapper">
            <div class="form-group" style="margin-bottom: 10px">
              <div class="btn-group mb-15" role="group" aria-label="...">
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{
                    'btn-active': model.serviceType === 'AirportTransfer',
                  }"
                  @click="onChangeServiceType('AirportTransfer')"
                >
                  Airport Transfer
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': model.serviceType === 'Rental' }"
                  @click="onChangeServiceType('Rental')"
                >
                  Hourly
                </button>
              </div>
            </div>
          </div>

          <div class="search-form-wrapper" id="search-form-wrapper">
            <div class="search-row-wrapper">
              <div
                class="pick-up-location-wrapper"
                :style="
                  !differentLocation &&
                  model.serviceType === 'Rental' &&
                  'width: 100%'
                "
              >
                <label>Pick-up Location</label>
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off"
                  tabindex="1"
                  name="pick-up-location"
                  v-model="model.pickUpLocation.name"
                  @focus="onFocusAutoComplete($event.target)"
                  @blur="onBlurAutoComplete($event.target)"
                  @keyup="onKeyupAutoComplete($event.target)"
                />
                <div class="list-autoComplete">
                  <ul
                    class="autoComplete-results"
                    id="autoComplete-pickupResults"
                  ></ul>
                </div>
              </div>
              <div class="drop-off-location-wrapper" v-if="showDropOffLocation">
                <label>Drop-off Location</label>
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off"
                  tabindex="1"
                  name="drop-off-location"
                  v-model="model.dropOffLocation.name"
                  @focus="onFocusAutoComplete($event.target)"
                  @blur="onBlurAutoComplete($event.target)"
                  @keyup="onKeyupAutoComplete($event.target)"
                />
                <div class="list-autoComplete">
                  <ul
                    class="autoComplete-results"
                    id="autoComplete-dropoffResults"
                  ></ul>
                </div>
              </div>
            </div>
            <div class="search-row-wrapper">
              <div
                class="pick-up-date-time-wrapper"
                :style="
                  model.serviceType === 'AirportTransfer' && 'width: 100%'
                "
              >
                <label>Pick-up Date & Time</label>
                <template>
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <i class="ic-date-checkin pl-5"></i>
                      <VueCtkDateTimePicker
                        id="repricing-date-time"
                        v-model="model.pickUpDate.date"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="MMM DD, YYYY"
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                        no-clear-button
                      />
                    </div>
                    <div class="col-sm-6">
                      <i class="ic-time"></i>
                      <VueCtkDateTimePicker
                        id="repricing-time"
                        v-model="model.pickUpDate.time"
                        color="#025BC5"
                        format="HH:mm"
                        formatted="HH:mm"
                        :minute-interval="
                          model.serviceType === 'AirportTransfer' ? 5 : 15
                        "
                        overlay
                        only-time
                        no-label
                        no-header
                        no-button
                        no-clear-button
                      />
                    </div>
                  </div>
                </template>
              </div>
              <div
                class="drop-off-date-time-wrapper"
                v-if="model.serviceType === 'Rental'"
              >
                <!-- <template v-if="model.serviceType === 'AirportTransfer'">
                  <label>Drop-off Date & Time</label>
                  <template>
                    <div class="wrap__input-box">
                      <div class="col-sm-6">
                        <i class="ic-date-checkin pl-5"></i>
                        <VueCtkDateTimePicker
                          id="repricing-date-time"
                          v-model="model.dropOffDate.date"
                          color="#025BC5"
                          format="YYYY-MM-DD"
                          formatted="MMM DD, YYYY"
                          auto-close
                          only-date
                          no-label
                          no-header
                          no-button
                          no-button-now
                          no-clear-button
                        />
                      </div>
                      <div class="col-sm-6">
                        <i class="ic-time"></i>
                        <VueCtkDateTimePicker
                          id="repricing-time"
                          v-model="model.dropOffDate.time"
                          color="#025BC5"
                          format="HH:mm"
                          formatted="HH:mm"
                          minute-interval="5"
                          overlay
                          only-time
                          no-label
                          no-header
                          no-button
                          no-clear-button
                        />
                      </div>
                    </div>
                  </template>
                </template> -->
                <template>
                  <label for="duration">Duration</label>
                  <template>
                    <div class="wrap__input-box" id="rentTime-wrapper">
                      <div class="col-sm-12">
                        <i class="ic-time plz"></i>
                        <span class="searchBox__input">
                          {{ model.durationInHour }}
                          {{ model.durationInHour === 1 ? "Hour" : "Hours" }}
                        </span>
                        <div class="repricingTime-box rentTime-box hidden">
                          <div>
                            <div class="col-sm-12">
                              <h5>
                                Duration
                                <span
                                  >{{ model.durationInHour }}
                                  {{
                                    model.durationInHour === 1
                                      ? "Hour"
                                      : "Hours"
                                  }}</span
                                >
                              </h5>
                              <div class="text-center">
                                <div class="col-sm-12 plz list-time">
                                  <ul
                                    class="picktime-hour"
                                    id="picktime-hour-item"
                                  >
                                    <li
                                      v-for="(item, index) in durationValue"
                                      :key="index"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        @click="onClickDurationPicker(item)"
                                        :class="{
                                          selected:
                                            item === model.durationInHour,
                                        }"
                                        >{{ item }}
                                        {{ item === 1 ? "Hour" : "Hours" }}</a
                                      >
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </div>

            <template v-if="model.serviceType === 'Rental'">
              <label class="cursor-pointer w-max-content"
                ><input
                  type="checkbox"
                  class="control-checkbox"
                  :value="differentLocation"
                  v-model="differentLocation"
                />
                <span class="pl-5 v-align-middle text-checkbox">
                  Drop off at different location
                </span></label
              >
            </template>
          </div>

          <div class="col-sm-12 mt-10" v-if="preBookingComponents.length">
            <div class="d-flex justify-between items-center">
              <h4>Pre Booking Components</h4>
              <button class="btn btn-add" @click="openModalPreBooking">
                Add Pre Booking
              </button>
            </div>
            <table class="repricing-table">
              <thead>
                <tr>
                  <th class="text-center">No</th>
                  <th class="text-left">Name</th>
                  <th class="text-center">Qty</th>
                  <th class="text-right">Buying ({{ currencyCode }})</th>
                  <th class="text-right">Selling ({{ currencyCode }})</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(component, index) in preBookingComponents"
                  :key="index"
                >
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>{{ component.name }}</td>
                  <template v-if="!component.isEdited">
                    <td class="text-center">
                      {{ component.qty ? component.qty : "-" }}
                    </td>
                    <td class="text-right">
                      {{
                        component.buyingRate || component.sellingRate === 0
                          ? $currencyFormat(
                              component.currency,
                              component.buyingRate
                            )
                          : "-"
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        component.sellingRate || component.sellingRate === 0
                          ? $currencyFormat(
                              component.currency,
                              component.sellingRate
                            )
                          : "-"
                      }}
                    </td>
                    <td v-if="!component.isEdited" class="text-center">
                      <button
                        class="btn-edit-repricing"
                        @click="onEditComponent(component, index)"
                      >
                        Edit
                      </button>
                      <button
                        class="btn-delete-repricing"
                        @click="deleteFareComponent(index)"
                        v-if="component.name.toLowerCase() !== 'base'"
                      >
                        Delete
                      </button>
                    </td>
                  </template>
                  <template v-else>
                    <td class="text-center">
                      <template v-if="checkQty(index, preBookingText)">
                        <input
                          type="number"
                          class="form-control-repricing numbers-only"
                          v-model.number="component.qty"
                          min="1"
                          @input="
                            onChangeQty(
                              index,
                              preBookingComponents,
                              masterPreBookingComponents
                            )
                          "
                        />
                      </template>
                      <template v-else>
                        <span>-</span>
                      </template>
                    </td>
                    <td class="text-center">
                      <template v-if="checkBuyingRate(index, preBookingText)">
                        <currency-input
                          ref="buyingRate"
                          class="form-control-repricing"
                          autocomplete="off"
                          placeholder="Enter buying rate"
                          name="buying"
                          v-model.number="component.buyingRate"
                          :allow-negative="false"
                          :currency="null"
                          :locale="currencyLocale"
                          :precision="currencyPrecision"
                        />
                      </template>
                      <template v-else><span>-</span></template>
                    </td>
                    <td class="text-center">
                      <template v-if="checkSellingRate(index, preBookingText)">
                        <currency-input
                          class="form-control-repricing"
                          autocomplete="off"
                          placeholder="Enter selling rate"
                          name="selling"
                          v-model.number="component.sellingRate"
                          :allow-negative="
                            component.name.toLowerCase() === 'markup'
                              ? true
                              : false
                          "
                          :currency="null"
                          :locale="currencyLocale"
                          :precision="currencyPrecision"
                        />
                      </template>
                      <template v-else><span>-</span></template>
                    </td>
                    <td class="d-flex justify-center items-center">
                      <button
                        class="btn-edit-check"
                        @click="validateConfirmEdit(index, preBookingText)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69L432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-sm-12">
            <div class="d-flex justify-between items-center">
              <h4>Post Booking Extra Services</h4>
              <button class="btn btn-add" @click="openModalPostBooking">
                Add Post Booking
              </button>
            </div>
            <table class="repricing-table">
              <thead>
                <tr>
                  <th class="text-center">No</th>
                  <th class="text-left">Name</th>
                  <th class="text-center">Qty</th>
                  <th class="text-right">Buying ({{ currencyCode }})</th>
                  <th class="text-right">Selling ({{ currencyCode }})</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody v-if="extraServices.length">
                <tr v-for="(extra, i) in extraServices" :key="i">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td>
                    {{
                      extra.name === "Fare Parking"
                        ? "Parking"
                        : extra.name === "Fare Toll"
                        ? "Tolls"
                        : extra.name
                    }}
                  </td>
                  <template v-if="!extra.isEdited">
                    <td class="text-center">
                      <template v-if="extra.qty">
                        {{ extra.qty }}
                        <span class="green__color">{{
                          extra.name === "Arrival Waiting Time" ||
                          extra.name === "Waiting Time"
                            ? "Min"
                            : null
                        }}</span>
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td class="text-right">
                      {{
                        extra.buyingRate
                          ? $currencyFormat(extra.currency, extra.buyingRate)
                          : "-"
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        extra.sellingRate || extra.sellingRate === 0
                          ? $currencyFormat(extra.currency, extra.sellingRate)
                          : "-"
                      }}
                    </td>
                    <td class="text-center">
                      <button
                        class="btn-edit-repricing"
                        @click="onEditExtra(extra, i)"
                      >
                        Edit
                      </button>
                      <button
                        class="btn-delete-repricing"
                        @click="deleteExtraService(i)"
                      >
                        Delete
                      </button>
                    </td>
                  </template>
                  <template v-else>
                    <td>
                      <template v-if="checkQty(i, postBookingText)">
                        <input
                          type="number"
                          class="form-control-repricing numbers-only"
                          v-model="extra.qty"
                          min="1"
                          @input="
                            onChangeQty(i, extraServices, masterExtraServices)
                          "
                        />
                      </template>
                      <template v-else><span>-</span></template>
                    </td>
                    <td>
                      <template v-if="checkBuyingRate(i, postBookingText)">
                        <currency-input
                          class="form-control-repricing"
                          autocomplete="off"
                          placeholder="Enter buying rate"
                          name="buying"
                          v-model="extra.buyingRate"
                          :allow-negative="false"
                          :currency="null"
                          :locale="currencyLocale"
                          :precision="currencyPrecision"
                        />
                      </template>
                      <template v-else><span>-</span></template>
                    </td>
                    <td>
                      <template v-if="checkSellingRate(i, postBookingText)">
                        <currency-input
                          class="form-control-repricing"
                          autocomplete="off"
                          placeholder="Enter selling rate"
                          name="selling"
                          v-model="extra.sellingRate"
                          :allow-negative="false"
                          :currency="null"
                          :locale="currencyLocale"
                          :precision="currencyPrecision"
                        />
                      </template>
                      <template v-else><span>-</span></template>
                    </td>
                    <td class="d-flex justify-center items-center">
                      <button
                        class="btn-edit-check"
                        @click="validateConfirmEdit(i, postBookingText)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69L432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </td>
                  </template>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">
                    <span class="svg-empty-box"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                      >
                        <g fill="none">
                          <path
                            d="M12 10c4.418 0 8-1.79 8-4s-3.582-4-8-4s-8 1.79-8 4s3.582 4 8 4zm6.328.17A7.61 7.61 0 0 0 20 9.053v3.204a5.477 5.477 0 0 0-4.02-1.233a11.687 11.687 0 0 0 2.348-.854zM11 16.5a5.502 5.502 0 0 0 3.831 5.242c-.88.167-1.834.258-2.831.258c-4.418 0-8-1.79-8-4V9.053a7.61 7.61 0 0 0 1.672 1.117C7.37 11.018 9.608 11.5 12 11.5c.958 0 1.892-.077 2.777-.225A5.502 5.502 0 0 0 11 16.5zm5.5 4.5a4.48 4.48 0 0 0 2.607-.832l2.613 2.612a.75.75 0 1 0 1.06-1.06l-2.612-2.613A4.5 4.5 0 1 0 16.5 21zm0-1.5a3 3 0 1 1 0-6a3 3 0 0 1 0 6z"
                            fill="currentColor"
                          ></path>
                        </g></svg
                    ></span>
                    <h5 class="label-empty-data">None.</h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-sm-7">
            <h4>Total</h4>
            <table class="repricing-table">
              <thead>
                <tr>
                  <td class="text-left">Name</td>
                  <td class="text-right">Buying</td>
                  <td class="text-right">Selling</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-left">- Pre Booking (Subtotal)</td>
                  <td class="text-right">
                    {{ currencyCode }}
                    {{ $currencyFormat(currencyCode, preBookingBuyingTotal) }}
                  </td>
                  <td class="text-right">
                    {{ currencyCode }}
                    {{ $currencyFormat(currencyCode, preBookingSellingTotal) }}
                  </td>
                </tr>
                <tr v-if="extraServices.length">
                  <td class="text-left">- Post Booking (Subtotal)</td>
                  <td class="text-right">
                    {{ currencyCode }}
                    {{ $currencyFormat(currencyCode, postBookingBuyingTotal) }}
                  </td>
                  <td class="text-right">
                    {{ currencyCode }}
                    {{ $currencyFormat(currencyCode, postBookingSellingTotal) }}
                  </td>
                </tr>
              </tbody>
              <tfoot class="tfoot-table">
                <tr>
                  <td class="text-left">TOTAL</td>
                  <td class="text-right">
                    {{ currencyCode }}
                    {{ $currencyFormat(currencyCode, grandBuyingTotal) }}
                  </td>
                  <td class="text-right">
                    {{ currencyCode }}
                    {{ $currencyFormat(currencyCode, grandSellingTotal) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="col-sm-5">
            <div class="repricing__profit__box">
              <div class="col-md-9 col-sm-12">
                <h4>Commission</h4>
                <table class="commision-table">
                  <tbody>
                    <tr>
                      <td>Booker</td>
                      <td>:</td>
                      <td>
                        {{ currencyCode }}
                        {{
                          $currencyFormat(
                            currencyCode,
                            commission.booker && this.commission.booker.amount
                              ? this.commission.booker.amount
                              : 0
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Operator</td>
                      <td>:</td>
                      <td>
                        {{ currencyCode }}
                        {{
                          $currencyFormat(
                            currencyCode,
                            commission.operator &&
                              this.commission.operator.amount
                              ? this.commission.operator.amount
                              : 0
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h4>Profit</h4>
                <table class="commision-table">
                  <tbody>
                    <tr>
                      <td>Total Selling</td>
                      <td>:</td>
                      <td>
                        {{ currencyCode }}
                        {{ $currencyFormat(currencyCode, grandSellingTotal) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Buying</td>
                      <td>:</td>
                      <td>
                        {{ currencyCode }}
                        {{ $currencyFormat(currencyCode, grandBuyingTotal) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Commission</td>
                      <td>:</td>
                      <td>
                        {{ currencyCode }}
                        {{ $currencyFormat(currencyCode, totalCommission) }}
                      </td>
                    </tr>
                    <tr
                      style="
                        border-left: none;
                        border-bottom: 2px dashed #a0a0a0;
                      "
                    ></tr>
                    <tr>
                      <td>Total Profit</td>
                      <td>:</td>
                      <td>
                        {{ currencyCode }}
                        {{ $currencyFormat(currencyCode, profitTotal) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="d-flex justify-end items-center gap-10">
              <router-link
                :to="
                  $route.path.includes('tenant')
                    ? '/job/tenant/' + $route.params.id
                    : '/reservation/inquiry/' + $route.params.id
                "
              >
                <button class="btn btn-cancel">Cancel</button>
              </router-link>
              <button
                class="btn btn-submit"
                @click.prevent="onSubmit()"
                :disabled="!preBookingEdited || !postBookingEdited"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FormPreBooking @submit="onSubmitComponent" />
    <FormPostBooking @submit="onSubmitComponent" />
    <ModalConfirmUpdate @submit="submitFromModal" />

    <ConfirmModal
      :id="'ConfirmationModal'"
      :header="'Confirmation'"
      :content="`The service type has been changed. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="onSubmit(true)"
    />

    <loader :content="msg" :visible="isLoading" />
  </div>
</template>

<script>
import _ from "lodash";
import ConfirmModal from "@/components/shared/ConfirmModal";
import FormPreBooking from "@/components/shared/FormPreBooking";
import FormPostBooking from "@/components/shared/FormPostBooking";
import ModalConfirmUpdate from "@/components/shared/ModalConfirmUpdate";
import inquiryReservationService from "@/services/shop/reservation/inquiryReservationService.js";
import fareComponentService from "@/services/master/fareComponent.js";
import maverickAutoComplete from "@/plugins/google/autocomplete.js";
import {
  ServiceType,
  PostBookingItem,
  PreBookingItem,
} from "@/models/constants";
import {
  calculateDropOffDate,
  convertDateTime,
} from "@/helpers/numberHelper.js";

const labelBooking = {
  postBookingText: "post-booking",
  preBookingText: "pre-booking",
};

export default {
  components: {
    FormPreBooking,
    FormPostBooking,
    ModalConfirmUpdate,
    ConfirmModal,
  },
  data() {
    return {
      autocomplete: null,
      durationValue: [],
      isLoading: false,
      ancillaries: [],
      reservation: null,
      currencyCode: null,
      commission: null,
      extraPreBooking: [],
      masterPreBookingComponents: [],
      preBookingComponents: [],
      tempDataEditComponent: null,
      extraPostBooking: [],
      masterExtraServices: [],
      extraServices: [],
      tempDataEditExtra: null,
      currencyLocale: "en-US",
      currencyPrecision: 2,
      msg: "Please wait ...",
      minHourly: 0,
      differentLocation: false,
      model: {
        serviceType: "Unspecified",
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
        pickUpDate: null,
        dropOffDate: null,
      },
    };
  },
  computed: {
    showDropOffLocation() {
      if (this.model.serviceType === "Rental") {
        return this.differentLocation;
      } else {
        return true;
      }
    },
    isAirportTransfer() {
      return (
        this.reservation &&
        this.reservation.serviceType === ServiceType.AirportTransferText
      );
    },
    preBookingBuyingTotal() {
      return (
        this.preBookingComponents.length > 0 &&
        this.preBookingComponents.reduce((initial, val) => {
          return initial + val.buyingRate;
        }, 0)
      );
    },
    preBookingSellingTotal() {
      return (
        this.preBookingComponents.length > 0 &&
        this.preBookingComponents.reduce((initial, val) => {
          return initial + val.sellingRate;
        }, 0)
      );
    },
    postBookingBuyingTotal() {
      return (
        this.extraServices.length > 0 &&
        this.extraServices.reduce((initial, val) => {
          return initial + val.buyingRate;
        }, 0)
      );
    },
    postBookingSellingTotal() {
      return (
        this.extraServices.length > 0 &&
        this.extraServices.reduce((initial, val) => {
          return initial + val.sellingRate;
        }, 0)
      );
    },
    grandBuyingTotal() {
      return this.preBookingBuyingTotal + this.postBookingBuyingTotal;
    },
    grandSellingTotal() {
      return this.preBookingSellingTotal + this.postBookingSellingTotal;
    },
    totalCommission() {
      const booker = this.commission.booker && this.commission.booker.amount;
      const masterFranchise =
        this.commission.masterFranchise &&
        this.commission.masterFranchise.amount;
      const operator =
        this.commission.operator && this.commission.operator.amount;
      return booker + masterFranchise + operator;
    },
    profitTotal() {
      return (
        this.grandSellingTotal - this.grandBuyingTotal - this.totalCommission
      );
    },
    preBookingText() {
      return labelBooking.preBookingText;
    },
    postBookingText() {
      return labelBooking.postBookingText;
    },
    preBookingEdited() {
      for (const item of this.preBookingComponents) {
        if (item.isEdited) {
          return false;
        }
      }
      return true;
    },
    postBookingEdited() {
      for (const item of this.extraServices) {
        if (item.isEdited) {
          return false;
        }
      }
      return true;
    },
  },
  async created() {
    this.isLoading = true;
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    const minHourly = publicSettings.find(
      (val) => val.key === "MinimumHourlyHire"
    );
    this.minHourly = minHourly.value;
    let tempDurationList = [];
    for (let i = minHourly.value; i <= 24; i++) {
      tempDurationList.push(Number(i));
    }
    this.durationValue = tempDurationList;

    this.autocomplete = await new maverickAutoComplete();
    await this.getRepricing();
    this.ancillaries = await this.getAvailableAncillaries();
    const preBooking = await this.getPreBookingComponent();
    const dataAncillaries = this.ancillaries.map((val) => ({
      label: val.name,
      value: val.name,
    }));
    const dataPreBooking = preBooking.map((val) => ({
      label: val,
      value: val,
    }));
    this.extraPreBooking = [...dataAncillaries, ...dataPreBooking];
    const postBooking = await this.getPostBookingComponent();
    this.extraPostBooking = postBooking.map((val) => ({
      label:
        val === PostBookingItem.fareParkingLabel
          ? "Parking"
          : val === PostBookingItem.fareTollLabel
          ? "Tolls"
          : val,
      value: val,
    }));
    this.$nextTick(() => this.sortingData());
    this.isLoading = false;
  },
  mounted() {
    document.addEventListener("click", (event) => {
      $.each(
        $(
          "#search-form-wrapper .list-autoComplete, #search-form-wrapper .popularCity"
        ),
        function (index, value) {
          value.classList.remove("isOpen");
        }
      );

      if ($("#search-form-wrapper .searchBox__input-from").is(event.target)) {
        const searchResult = $(event.target.parentElement).find(
          ".list-autoComplete"
        );
        const popularCity = $(event.target.parentElement).find(".popularCity");
        if (
          searchResult.length > 0 &&
          searchResult[0].getElementsByTagName("li").length > 0
        ) {
          searchResult[0].classList.add("isOpen");
        } else if (
          popularCity.length > 0 &&
          popularCity[0].getElementsByTagName("li").length > 0
        ) {
          popularCity[0].classList.add("isOpen");
        }
      }
    });

    document.addEventListener("click", (event) => {
      const rentTimeWrapper = document.querySelector("#rentTime-wrapper");
      if (rentTimeWrapper) {
        if (
          rentTimeWrapper.contains(event.target) &&
          !event.target.parentElement.classList.contains("apply-renttime")
        ) {
          document.querySelector(".rentTime-box").classList.remove("hidden");
        } else {
          document.querySelector(".rentTime-box").classList.add("hidden");
        }
      }
    });
  },
  methods: {
    onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete(target) {
      if (target.name === "pick-up-location")
        target.value = this.model.pickUpLocation.name;
      else target.value = this.model.dropOffLocation.name;
    },
    onKeyupAutoComplete(target) {
      let self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout((_) => {
        let element;

        if (target.name === "pick-up-location") {
          element = document.getElementById("autoComplete-pickupResults");
        } else {
          element = document.getElementById("autoComplete-dropoffResults");
        }

        // reset suggestion result
        element.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          element.parentElement.classList.remove("isOpen");
          return;
        }
        // const options = {
        //   country: this.searchParameter.pickUpLocation.country,
        // };
        self.autocomplete.getPredictions(
          target.value,
          (predictions) => {
            // loop result
            predictions.forEach(function (prediction) {
              const item = document.createElement("li");
              item.className = "list-result-autocomplete";
              item.innerHTML = `${self.$helper.getPlaceIcon(
                prediction.types
              )}<div><div class='point-of-view'>${
                prediction.structured_formatting.main_text
              }</div><span class='address-list-autocomplete'>${
                prediction.structured_formatting.secondary_text
              }</span></div>`;
              item.addEventListener("click", (_) =>
                self.getPlace(target, prediction)
              );
              element.appendChild(item);
            });
            // show the result
            element.parentElement.classList.add("isOpen");
          }
          // options // this code for country (not mandatory)
        );
      }, 200);
    },
    getPlace(target, prediction) {
      const self = this;
      self.autocomplete.getPlace(prediction, (place) => {
        const isAirportZone = prediction.types.includes("airport")
          ? true
          : false;

        if (target.name === "pick-up-location") {
          self.model.pickUpLocation = {
            latitude: place.latitude,
            longitude: place.longitude,
            name: place.name,
            address: place.address,
            country: place.country,
            isAirportZone,
          };
        } else {
          self.model.dropOffLocation = {
            latitude: place.latitude,
            longitude: place.longitude,
            name: place.name,
            address: place.address,
            country: place.country,
            isAirportZone,
          };
        }
        // everytime user select the prediction, result list should be reset
        document.getElementById("autoComplete-pickupResults").innerHTML = "";
        document.getElementById("autoComplete-dropoffResults").innerHTML = "";
      });
    },
    onChangeServiceType(val) {
      this.model.serviceType = val;
    },
    sortingData() {
      let baseData = [];
      let ancillariesData = [];
      let surchargesData = [];
      let baseDataMaster = [];
      let ancillariesDataMaster = [];
      let surchargesDataMaster = [];

      this.preBookingComponents.forEach((val) => {
        if (
          val.name === PreBookingItem.baseLabel ||
          val.name === PreBookingItem.markupLabel
        ) {
          baseData.push(val);
          return;
        }

        const findAncill = this.ancillaries.find((el) => el.name === val.name);
        if (findAncill) {
          ancillariesData.push(val);
        } else {
          surchargesData.push(val);
        }
      });

      baseData.sort((a, b) => a.name.localeCompare(b.name));
      this.$nextTick(
        () =>
          (this.preBookingComponents = baseData
            .concat(surchargesData.sort((a, b) => a.name.localeCompare(b.name)))
            .concat(
              ancillariesData.sort((a, b) => a.name.localeCompare(b.name))
            ))
      );

      this.masterPreBookingComponents.forEach((val) => {
        if (
          val.name === PreBookingItem.baseLabel ||
          val.name === PreBookingItem.markupLabel
        ) {
          baseDataMaster.push(val);
          return;
        }

        const findAncillMaster = this.ancillaries.find(
          (el) => el.name === val.name
        );
        if (findAncillMaster) {
          ancillariesDataMaster.push(val);
        } else {
          surchargesDataMaster.push(val);
        }
      });

      baseDataMaster.sort((a, b) => a.name.localeCompare(b.name));
      this.$nextTick(
        () =>
          (this.masterPreBookingComponents = baseDataMaster
            .concat(
              surchargesDataMaster.sort((a, b) => a.name.localeCompare(b.name))
            )
            .concat(
              ancillariesDataMaster.sort((a, b) => a.name.localeCompare(b.name))
            ))
      );
    },
    async getRepricing() {
      try {
        const response = await inquiryReservationService.repricing(
          this.$route.params.id
        );

        const equal = _.isEqual(
          response.pickUpLocation,
          response.dropOffLocation
        );

        this.differentLocation = equal ? false : true;

        this.reservation = {
          paymentStatus: response.paymentStatus,
          paymentMethodDescription: response.paymentMethodDescription,
          reservationDate: response.reservationDate,
          code: response.reservationCode,
          serviceType: response.serviceType,
        };

        this.model = {
          serviceType: response.serviceType,
          pickUpLocation: response.pickUpLocation,
          dropOffLocation: response.dropOffLocation,
          pickUpDate: {
            date: `${response.pickUpDate.year}-${response.pickUpDate.stringMonth}-${response.pickUpDate.stringDate}`,
            time: `${response.pickUpDate.stringHour}:${response.pickUpDate.stringMinute}`,
          },
          dropOffDate: {
            date: `${response.dropOffDate.year}-${response.dropOffDate.stringMonth}-${response.dropOffDate.stringDate}`,
            time: `${response.dropOffDate.stringHour}:${response.dropOffDate.stringMinute}`,
          },
          durationInHour:
            response.serviceType === "Rental"
              ? response.durationInMinutes / 60
              : this.minHourly,
        };

        if (!Number.isInteger(this.model.durationInHour)) {
          this.model.durationInHour = Math.round(this.model.durationInHour);
        }

        this.commission = response.commission;
        this.masterPreBookingComponents = response.preBookingComponents;
        this.masterExtraServices = response.extraServices;
        this.preBookingComponents = response.preBookingComponents.map(
          (val) => ({ ...val, isEdited: false })
        );
        this.extraServices = response.extraServices.map((val) => ({
          ...val,
          isEdited: false,
        }));
        this.currencyCode = response.preBookingComponents[0].currency;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getAvailableAncillaries() {
      try {
        const response =
          await inquiryReservationService.getAvailableAncillaries(
            this.$route.params.id
          );

        return response;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getPreBookingComponent() {
      try {
        const response = await fareComponentService.getPreBookingComponent();

        return response;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getPostBookingComponent() {
      try {
        const response = await fareComponentService.getPostBookingComponent();

        return response;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    isDropOffDateInvalid(pickUpDate, dropOffDate) {
      const pickUp = new Date(`${pickUpDate.date}T${pickUpDate.time}`);
      const dropOff = new Date(`${dropOffDate.date}T${dropOffDate.time}`);

      return pickUp >= dropOff;
    },
    async onSubmit(confirm = false) {
      if (!confirm && this.reservation.serviceType !== this.model.serviceType) {
        $("#ConfirmationModal").modal({
          backdrop: "static",
          keyboard: false,
        });
        return;
      }

      // const isDropOffDateInvalid = this.isDropOffDateInvalid(
      //   this.model.pickUpDate,
      //   this.model.dropOffDate
      // );

      // if (
      //   this.model.serviceType === ServiceType.AirportTransferText &&
      //   isDropOffDateInvalid
      // ) {
      //   const message =
      //     "Drop-off date time can't be lower than the pick-up date time.";
      //   const buttonProcess = false;
      //   this.$eventBus.$emit(
      //     "ConfirmEdit",
      //     "idx",
      //     message,
      //     "warning",
      //     buttonProcess
      //   );
      //   return;
      // }

      this.isLoading = true;
      try {
        let date;

        if (this.model.serviceType === "Rental") {
          date = calculateDropOffDate({
            ...this.model.pickUpDate,
            durationInHour: this.model.durationInHour,
          });
        } else {
          const pickUp = convertDateTime(this.model.pickUpDate);
          const dropOff = convertDateTime(this.model.dropOffDate);

          date = { pickUp, dropOff };
        }

        let payload = {
          serviceType: this.model.serviceType,
          pickUpLocation: this.model.pickUpLocation,
          dropOffLocation: this.model.dropOffLocation,
          pickUpDate: date.pickUp,
          dropOffDate: date.dropOff,
          dropOffDate: this.model.serviceType === ServiceType.RentalHourlyText ? date.dropOff : null,
          notes: "",
          commission: this.commission,
          preBookingComponents: this.preBookingComponents,
          extraServices: this.extraServices,
        };

        if (this.model.serviceType === "Rental" && !this.differentLocation) {
          payload = {
            ...payload,
            dropOffLocation: this.model.pickUpLocation,
          };
        }

        const response = await inquiryReservationService.submitRepricing(
          this.$route.params.id,
          payload
        );

        if (response.isSuccess) {
          this.$notification.success("Successfully repriced.", {
            title: "Success",
          });

          if (this.$route.path.includes("tenant")) {
            this.$router.push({
              path: `/job/tenant/${this.$route.params.id}`,
            });
          } else {
            this.$router.push({
              path: `/reservation/inquiry/${this.$route.params.id}`,
            });
          }
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onSubmitComponent(typeBooking, data) {
      let payload = {
        ...data,
        buyingRateId: null,
        currency: this.currencyCode,
        evidenceId: null,
        qty: data.qty ? Number(data.qty) : null,
        referenceId: null,
        sellingRateId: null,
      };
      if (typeBooking === this.preBookingText) {
        const find = this.ancillaries.find((val) => val.name === data.name);
        if (find) {
          payload = { ...payload, referenceId: find.id };
        }
        this.masterPreBookingComponents.push(payload);
        this.preBookingComponents.push({ ...payload, isEdited: false });

        this.calculateAmountBooker();
        this.calculateAmountMasterFranchise();
        this.calculateAmountOperator();
      }
      if (typeBooking === this.postBookingText) {
        this.masterExtraServices.push(payload);
        this.extraServices.push({ ...payload, isEdited: false });
      }

      this.$nextTick(() => this.sortingData());
    },
    onEditComponent(val, idx) {
      this.tempDataEditComponent = val;
      this.preBookingComponents[idx].isEdited =
        !this.preBookingComponents[idx].isEdited;
    },
    deleteFareComponent(index) {
      this.preBookingComponents = this.preBookingComponents.filter(
        (_, idx) => idx !== index
      );
      this.masterPreBookingComponents = this.masterPreBookingComponents.filter(
        (_, idx) => idx !== index
      );

      this.calculateAmountBooker();
      this.calculateAmountMasterFranchise();
      this.calculateAmountOperator();
    },
    validateConfirmEdit(idx, label) {
      if (label === this.preBookingText) {
        const getAncillary = this.ancillaries.find(
          (val) => val.name === this.preBookingComponents[idx].name
        );

        if (getAncillary) {
          if (!this.preBookingComponents[idx].qty) {
            const message = "Minimum quantity must be 1 or more than 1.";
            const buttonProcess = false;
            this.$eventBus.$emit(
              "ConfirmEdit",
              idx,
              message,
              label,
              buttonProcess
            );
            return;
          }
        }

        if (
          this.preBookingComponents[idx].name !== PreBookingItem.markupLabel &&
          !this.preBookingComponents[idx].buyingRate &&
          !this.preBookingComponents[idx].sellingRate
        ) {
          const message =
            "There are no prices entered for both buying and selling. Do you wish to proceed?";
          const buttonProcess = true;
          this.$eventBus.$emit(
            "ConfirmEdit",
            idx,
            message,
            label,
            buttonProcess
          );
          return;
        }

        if (
          this.preBookingComponents[idx].buyingRate >
            this.preBookingComponents[idx].sellingRate &&
          this.preBookingComponents[idx].name !== PreBookingItem.markupLabel
        ) {
          const message =
            "The selling price is lower than the buying price. Do you wish to proceed?";
          const buttonProcess = true;
          this.$eventBus.$emit(
            "ConfirmEdit",
            idx,
            message,
            label,
            buttonProcess
          );
          return;
        }

        if (
          this.preBookingComponents[idx].name === PreBookingItem.markupLabel &&
          !this.preBookingComponents[idx].sellingRate
        ) {
          const message =
            "No price entered for selling markup. Please check again.";
          const buttonProcess = false;
          this.$eventBus.$emit(
            "ConfirmEdit",
            idx,
            message,
            label,
            buttonProcess
          );
          return;
        }

        this.onConfirmEditComponent(idx);
      }

      if (label === this.postBookingText) {
        if (
          this.extraServices[idx].name === PostBookingItem.fareParkingLabel ||
          this.extraServices[idx].name === PostBookingItem.fareTollLabel
        ) {
          if (!this.extraServices[idx].buyingRate) {
            const message =
              "There are no prices entered for buying rate. Please check again.";
            const buttonProcess = false;
            this.$eventBus.$emit(
              "ConfirmEdit",
              idx,
              message,
              label,
              buttonProcess
            );
            return;
          }
          this.onConfirmEditExtra(idx);
          return;
        }

        if (!this.extraServices[idx].qty) {
          const message = "Minimum quantity must be 1 or more than 1.";
          const buttonProcess = false;
          this.$eventBus.$emit(
            "ConfirmEdit",
            idx,
            message,
            label,
            buttonProcess
          );
          return;
        }

        if (
          !this.extraServices[idx].buyingRate &&
          !this.extraServices[idx].sellingRate
        ) {
          const message =
            "There are no prices entered for both buying and selling. Please check again.";
          const buttonProcess = false;
          this.$eventBus.$emit(
            "ConfirmEdit",
            idx,
            message,
            label,
            buttonProcess
          );
          return;
        }

        if (
          this.extraServices[idx].buyingRate >
          this.extraServices[idx].sellingRate
        ) {
          const message =
            "The selling price is lower than the buying price. Do you wish to proceed?";
          const buttonProcess = true;
          this.$eventBus.$emit(
            "ConfirmEdit",
            idx,
            message,
            label,
            buttonProcess
          );
          return;
        }

        this.onConfirmEditExtra(idx);
      }
    },
    submitFromModal(idx, label) {
      if (label === this.preBookingText) {
        this.onConfirmEditComponent(idx);
        return;
      }

      if (label === this.postBookingText) {
        this.onConfirmEditExtra(idx);
        return;
      }
    },
    onConfirmEditComponent(idx) {
      const tempData = this.preBookingComponents[idx];
      this.preBookingComponents[idx].isEdited =
        !this.preBookingComponents[idx].isEdited;
      this.tempDataEditComponent = null;

      if (
        tempData.name.toLowerCase() === "base" ||
        tempData.name.toLowerCase() === "markup"
      ) {
        this.calculateAmountBooker();
        this.calculateAmountMasterFranchise();
        this.calculateAmountOperator();
      }
    },
    onEditExtra(val, idx) {
      this.tempDataEditExtra = val;
      this.extraServices[idx].isEdited = !this.extraServices[idx].isEdited;
    },
    deleteExtraService(index) {
      this.extraServices = this.extraServices.filter((_, i) => i !== index);
      this.masterExtraServices = this.masterExtraServices.filter(
        (_, idx) => idx !== index
      );

      this.calculateAmountBooker();
      this.calculateAmountMasterFranchise();
      this.calculateAmountOperator();
    },
    onConfirmEditExtra(idx) {
      this.extraServices[idx].isEdited = !this.extraServices[idx].isEdited;
      this.tempDataEditExtra = null;
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    checkQty(i, label) {
      if (label === this.preBookingText) {
        return this.masterPreBookingComponents[i].qty;
      } else {
        return this.masterExtraServices[i].qty;
      }
    },
    checkBuyingRate(i, label) {
      if (label === this.preBookingText) {
        return (
          this.masterPreBookingComponents[i].buyingRate !== null ||
          this.preBookingComponents[i].name.toLowerCase() !== "markup"
        );
      } else {
        return this.masterExtraServices[i].buyingRate !== null;
      }
    },
    checkSellingRate(i, label) {
      if (label === this.preBookingText) {
        return this.masterPreBookingComponents[i].sellingRate !== null;
      } else {
        return this.masterExtraServices[i].sellingRate !== null;
      }
    },
    openModalPreBooking() {
      const preBooking = this.getResultArray(
        this.preBookingComponents,
        this.extraPreBooking
      );
      this.$eventBus.$emit("FormPreBooking", preBooking);
    },
    openModalPostBooking() {
      const postBooking = this.getResultArray(
        this.extraServices,
        this.extraPostBooking
      );
      this.$eventBus.$emit("FormPostBooking", postBooking);
    },
    getResultArray(dataMaster, dataExtra) {
      let result = [];
      for (const extraItem of dataExtra) {
        const isMatching = dataMaster.some(
          (masterItem) => masterItem.name === extraItem.value
        );
        if (!isMatching) {
          result.push({ ...extraItem });
        }
      }
      return result;
    },
    onClickDurationPicker(hours) {
      this.model.durationInHour = hours;
    },
    calculateAmountBooker() {
      const findBaseFare = this.preBookingComponents.find(
        (val) => val.name.toLowerCase() === "base"
      );

      const findMarkup = this.preBookingComponents.find(
        (val) => val.name.toLowerCase() === "markup"
      );

      if (this.commission && this.commission.booker) {
        if (!findMarkup) {
          this.commission.booker.amount = this.commission.booker.isPercentage
            ? findBaseFare.sellingRate * (this.commission.booker.rate / 100)
            : this.commission.booker.rate;
          return;
        }

        this.commission.booker.amount = this.commission.booker.isPercentage
          ? (findBaseFare.sellingRate + findMarkup.sellingRate) *
            (this.commission.booker.rate / 100)
          : this.commission.booker.rate;
      }
    },
    calculateAmountMasterFranchise() {
      const findBaseFare = this.preBookingComponents.find(
        (val) => val.name.toLowerCase() === "base"
      );

      if (this.commission && this.commission.masterFranchise) {
        this.commission.masterFranchise.amount = this.commission.masterFranchise
          .isPercentage
          ? findBaseFare.buyingRate *
            (this.commission.masterFranchise.rate / 100)
          : this.commission.masterFranchise.rate;
      }
    },
    calculateAmountOperator() {
      const findBaseFare = this.preBookingComponents.find(
        (val) => val.name.toLowerCase() === "base"
      );

      if (this.commission && this.commission.operator) {
        this.commission.operator.amount = this.commission.operator.isPercentage
          ? findBaseFare.buyingRate * (this.commission.operator.rate / 100)
          : this.commission.operator.rate;
      }
    },
    onChangeQty(indexItem, fareComponents, currentFareComponents) {
      let fareComponentItem = fareComponents[indexItem];
      let currentFareComponentItem = currentFareComponents[indexItem];

      fareComponentItem.buyingRate =
        (currentFareComponentItem.buyingRate / currentFareComponentItem.qty) *
        fareComponentItem.qty;

      fareComponentItem.sellingRate =
        (currentFareComponentItem.sellingRate / currentFareComponentItem.qty) *
        fareComponentItem.qty;
    },
  },
  updated() {
    this.$helper.numbersOnly();
  },
  beforeDestroy() {
    this.$eventBus.$off("FormPreBooking");
    this.$eventBus.$off("FormPostBooking");
    this.$eventBus.$off("ConfirmEdit");
  },
};
</script>

<style scoped>
.service-type-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

h4 {
  font-weight: 700;
  font-size: 1.2rem;
}

.repricing-table {
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  width: 100%;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.repricing-table thead tr {
  background-color: #a0a0a0;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
}

.repricing-table thead tr th:first-child {
  width: 10px;
}

.repricing-table thead tr th:nth-child(2) {
  width: 25%;
}

.repricing-table thead tr th:nth-child(3) {
  width: 10%;
}

.repricing-table thead tr th:nth-child(4),
.repricing-table thead tr th:nth-child(5) {
  width: max-content;
}

.repricing-table thead.total-head {
  font-size: 1.2em;
}

.repricing-table th {
  font-size: 1em;
  font-weight: 900;
}

.repricing-table th,
.repricing-table td {
  padding: 12px 15px;
}

.repricing-table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.repricing-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.repricing-table tbody tr:last-of-type {
  border-bottom: 2px solid #a0a0a0;
}

.repricing-table tfoot.tfoot-table {
  font-size: 1.1em;
  font-weight: bolder;
  color: #009879;
}

.repricing-table td.flex-end {
  display: flex;
  justify-content: flex-end;
}

table.commision-table {
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 1.1em;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  font-weight: 500;
}

table.commision-table tbody {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

table.commision-table tr {
  border-left: 4px solid #a0a0a0;
  border-radius: 5px;
}

table.commision-table tr td:first-child {
  padding-left: 10px;
  width: 150px;
}

table.commision-table tr td:nth-child(2) {
  width: 20px;
}

table.commision-table tr td:last-child {
  min-width: 120px;
  text-align: right;
}

button.btn-close-modal {
  padding: 8px;
  border-radius: 100%;
}

button.btn-close-modal:hover {
  background: #a0a0a0;
}

button.btn-edit-repricing {
  padding: 3px 20px;
  border-radius: 5px;
  outline: none;
  border: none;
  background-color: #fff;
  border: 1px solid rgb(79, 184, 72);
  color: rgb(79, 184, 72);
}

button.btn-delete-repricing {
  padding: 3px 20px;
  border-radius: 5px;
  outline: none;
  border: none;
  background-color: #fff;
  border: 1px solid rgb(255, 0, 0);
  color: rgb(255, 0, 0);
}

button.btn-edit-repricing:hover {
  background-color: rgb(79, 184, 72);
  color: #fff;
  font-weight: 700;
}

button.btn-delete-repricing:hover {
  background-color: rgb(255, 0, 0);
  color: #fff;
  font-weight: 700;
}

button.btn-edit-check {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 20px;
  border-radius: 5px;
  outline: none;
  border: none;
  background-color: #fff;
  border: 1px solid rgb(79, 184, 72);
  color: rgb(79, 184, 72);
}

button.btn-edit-check:hover {
  background-color: rgb(79, 184, 72);
  color: #fff;
  font-weight: 700;
}

button.btn-edit-wrong {
  padding: 3px 20px;
  border-radius: 5px;
  outline: none;
  border: none;
  background-color: #fff;
  border: 1px solid rgb(255, 0, 0);
  color: rgb(255, 0, 0);
}

button.btn-edit-wrong:hover {
  background-color: rgb(255, 0, 0);
  color: #fff;
  font-weight: 700;
}

.btn.btn-add {
  background: #4fb848;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 6px 20px;
  text-transform: uppercase;
  outline: none;
}

.btn.btn-add:hover {
  background: #339c2b;
}

.btn.btn-submit {
  background: #4fb848;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}

.btn.btn-cancel {
  background: #a0a0a0;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}

.btn.btn-submit:hover {
  background: #339c2b;
}

.btn.btn-cancel:hover {
  background: #888888;
}

.gap-10 {
  gap: 10px;
}

span.blue__color {
  color: #5499e4;
}

.repricing_box_date_time {
  position: relative;
  display: flex;
  width: 70%;
  padding: 10px 20px;
  border-radius: 5px;
  border: 1px solid #dddddd;
  gap: 10px;
  margin: 0 auto;
}

.repricing_box_date_time .date_time_box {
  display: flex;
  flex-direction: column;
  width: 60%;
}

.repricing_box_date_time .duration_box {
  width: 40%;
}

input#repricing-date-time-input.field-input {
  border: none !important;
  outline: none !important;
}

.repricingTime-box.rentTime-box {
  width: 100%;
  height: 300px;
}

.repricing__profit__box {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: auto;
}

button svg {
  width: 20px;
}

span.svg-empty-box svg {
  width: 80px;
  color: #a0a0a0;
}

h5.label-empty-data {
  font-weight: 800;
  color: #a0a0a0;
}

span.green__color {
  color: #009879;
}

.text-checkbox {
  color: #4a4a4a;
  font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Repricing.vue